import { createSlice } from '@reduxjs/toolkit';

export const SUPPORT_TYPES = {
  SUPPORT: 'Support',
  FEEDBACK: 'Feedback',
};

export const supportDrawerSlice = createSlice({
  name: 'supportDrawer',
  initialState: {
    isOpen: false,
    supportType: SUPPORT_TYPES.SUPPORT,
  },
  reducers: {
    openSupportDrawer: (state, action) => {
      state.isOpen = true;
      state.supportType = action.payload || SUPPORT_TYPES.SUPPORT;
    },
    closeSupportDrawer: state => {
      state.isOpen = false;
    },
  },
});

export const { openSupportDrawer, closeSupportDrawer } = supportDrawerSlice.actions;

export default supportDrawerSlice.reducer;
